import { apiClient } from './client';
import type { OperationDraft, MissingFieldEntry } from '../types/api.types';

export interface CompleteIncompleteDraftInput {
  loteId?: string;
  loteName?: string;
  totalCost?: number;
  occurredAt?: string;
  notes?: string;
}

export interface CompleteIncompleteDraftResult {
  status: 'DRAFT_COMPLETED' | 'STILL_INCOMPLETE';
  missingFields?: MissingFieldEntry[];
}

export const fetchIncompleteDrafts = async (): Promise<OperationDraft[]> =>
  (await apiClient.get('/api/incomplete-drafts')).data;

export const fetchIncompleteDraft = async (draftId: string): Promise<OperationDraft> =>
  (await apiClient.get(`/api/incomplete-drafts/${draftId}`)).data;

export const completeIncompleteDraft = async (
  draftId: string, input: CompleteIncompleteDraftInput,
): Promise<CompleteIncompleteDraftResult> =>
  (await apiClient.post(`/api/incomplete-drafts/${draftId}/complete`, input)).data;

export const cancelIncompleteDraft = async (draftId: string): Promise<void> =>
  (await apiClient.post(`/api/incomplete-drafts/${draftId}/cancel`)).data;

// ── Fase 3 — vista de supervisión (requiere operations:supervise) ───────────

export interface SupervisedDraftEntry {
  draft: OperationDraft;
  ownerPhoneNumber: string;
  ownerName?: string;
}

export const fetchTeamIncompleteDrafts = async (): Promise<SupervisedDraftEntry[]> =>
  (await apiClient.get('/api/incomplete-drafts/team')).data;
